/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import ApiCaller from "~/api/ApiCaller";
import {
  GetListBlackLabelSiteReviewResponse,
  GetMyPromotionSitesResponse,
  GetPostbackListRequestBody,
  GetPostbackListResponse,
  GetPromotionSitesResponse,
  GetSiteListResponse,
  GetSitePromotionListResponse,
  GetTimezonesResponse,
  PostAddPostbackRequestBody,
  PostAddPostbackResponse,
  PostCreateBlackLabelSiteRequestBody,
  PostCreateBlackLabelSiteResponse,
  PostCreatePromotionPayload,
  PostCreatePromotionResponse,
  PostCreateSiteDraftPayload,
  PostCreateSiteDraftResponse,
  PostDeletePostbackRequestBody,
  PostDeletePostbackResponse,
  PostEditPostbackRequestBody,
  PostEditPostbackResponse,
  PostUpdateJoinTypePayload,
  PostUpdateJoinTypeResponse,
  PostValidatePostbackRequestBody,
  PostValidatePostbackResponse,
  PostValidateWhitelabelDomainPayload,
  PostValidateWhitelabelDomainResponse,
} from "~/features/mySites/types";

const MySitesApi = {
  getSiteList: () => ApiCaller.get<GetSiteListResponse>("/v1/site/sitelist"),
  getSitePromotionList: () => ApiCaller.get<GetSitePromotionListResponse>("/v1/sitepromotion/sitepromotionlist"),

  getMyPromotionSites: () => ApiCaller.get<GetMyPromotionSitesResponse>("/v1/sitepromotion/promotionswithrevenue"),

  // CREATE NEW WHITE LABEL
  postValidateWhitelabelDomain: (payload: PostValidateWhitelabelDomainPayload) =>
    ApiCaller.post<PostValidateWhitelabelDomainResponse>("/v1/site/validatewhitelabeldomain", payload),

  postCreateSiteDraft: (payload: PostCreateSiteDraftPayload) =>
    ApiCaller.post<PostCreateSiteDraftResponse>("/v1/site/createdraft", payload),

  postUpdateJoinType: (payload: PostUpdateJoinTypePayload) =>
    ApiCaller.post<PostUpdateJoinTypeResponse>("/v1/site/updatejointypeinreview", payload),

  // PROMOTE SITE
  getPromotionSites: () => ApiCaller.get<GetPromotionSitesResponse>("/v1/sitepromotion/promotions"),

  postCreatePromotion: (payload: PostCreatePromotionPayload) =>
    ApiCaller.post<PostCreatePromotionResponse>("/v1/sitepromotion/createpromotion", payload),

  // POSTBACKS
  getPostbackList: (payload: GetPostbackListRequestBody) =>
    ApiCaller.get<GetPostbackListResponse>("/v1/postback/list", { params: payload }),

  postAddPostback: (payload: PostAddPostbackRequestBody) =>
    ApiCaller.post<PostAddPostbackResponse>("/v1/postback/create", payload),

  postEditPostback: (payload: PostEditPostbackRequestBody) =>
    ApiCaller.post<PostEditPostbackResponse>("/v1/postback/update", payload),

  postDeletePostback: (payload: PostDeletePostbackRequestBody) =>
    ApiCaller.post<PostDeletePostbackResponse>("/v1/postback/delete", payload),

  postValidatePostback: (payload: PostValidatePostbackRequestBody) =>
    ApiCaller.post<PostValidatePostbackResponse>("/v1/postback/validate", payload),

  // BLACK LABEL
  postCreateBLackLabelSiteReview: (payload: PostCreateBlackLabelSiteRequestBody) =>
    ApiCaller.post<PostCreateBlackLabelSiteResponse>("/v1/blacklabel/createsitereview", payload),

  getTimezones: () => ApiCaller.get<GetTimezonesResponse>("/v1/blacklabel/timezones"),

  getListBLackLabelSiteReview: () =>
    ApiCaller.get<GetListBlackLabelSiteReviewResponse>("/v1/blacklabel/listsitereview"),
};

export default MySitesApi;
